// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dedicated names keep dashboard cards independent of Bootstrap and other pages. */
.scada-dash-page {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(0, 1.1fr);
  align-items: start;
  gap: 16px;
  padding: 16px;
  min-height: 0;
  min-width: 0;
  overflow: auto;
  box-sizing: border-box;
  color: #fff;
  background: radial-gradient(circle, #07af64 0%, #128a80 58%, #19dccf 100%);
}

.scada-dash-left-column,
.scada-dash-right-column {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 14px;
}

.scada-dash-status-bar {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  border-radius: 6px;
  color: #f1f5f9;
  background: radial-gradient(ellipse at top right, #586170 0%, #586170 38%, transparent 38%), #3c4556;
}

.scada-dash-status-bar > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.scada-dash-status-title {
  font-size: 15px;
  font-weight: 700;
  color: #f1f5f9;
  text-transform: uppercase;
}

.scada-dash-status-live {
  flex-shrink: 0;
  padding: 3px 6px;
}

.scada-dash-row-container {
  display: flex;
  align-items: center;
}

.scada-dash-status-badge {
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  color: #040c32;
  background: #1ded88;
}

.scada-dash-cards-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 16px;
}

.scada-dash-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  min-height: 118px;
  padding: 12px;
  border: 1px solid #d6e5e9;
  border-radius: 6px;
  color: #fff !important;
  background: #000 !important;
}

.scada-dash-card-header {
  padding: 4px 0;
  color: #e5e7eb !important;
  font-size: 13px;
}

.scada-dash-card-title {
  text-transform: uppercase;
  overflow-wrap: anywhere;
  letter-spacing: 0.04em;
}

.scada-dash-card-value {
  padding: 12px 0;
  color: #fff !important;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  overflow-wrap: anywhere;
}

.scada-dash-card-unit {
  color: #e5e7eb !important;
  font-size: 11px;
  white-space: nowrap;
}

.scada-dash-card-footer {
  color: #ecf1ef !important;
  font-size: 10px;
}

/* Keep readings visible, including measurements above the configured limit. */
.scada-dash-card-danger .scada-dash-card-value {
  color: #ff6b6b !important;
}

.scada-dash-info-header,
.scada-dash-map-card {
  padding: 10px;
  border: 1px solid #2f3a56;
  border-radius: 8px;
  background: #0b1020;
}

.scada-dash-labelULB {
  padding: 10px;
  border-radius: 8px;
  background: #7d15c2;
  color: #fff;
}

.scada-dash-label {
  color: #ffe600;
}

.scada-dash-labeBack {
  background: #bca5cb;
  color: #17031f;
  font-size: 15px;
  font-weight: 700;
}

.scada-dash-map-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 260px;
  margin-bottom: 12px;
  border: 1px solid #1f2937;
  border-radius: 6px;
  background: radial-gradient(circle at top, #1f2937, #020617);
}

.scada-dash-bottom-section:empty {
  display: none;
}

@media (max-width: 1200px) {
  .scada-dash-page {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 640px) {
  .scada-dash-cards-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .scada-dash-status-bar > div:first-child {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/GisTools/SCADADashboard.css"],"names":[],"mappings":"AAAA,mFAAmF;AACnF;EACE,aAAa;EACb,wDAAwD;EACxD,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,aAAa;EACb,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,0EAA0E;AAC5E;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,oGAAoG;AACtG;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,8EAA8E;AAC9E;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Dedicated names keep dashboard cards independent of Bootstrap and other pages. */\n.scada-dash-page {\n  display: grid;\n  grid-template-columns: minmax(0, 2.2fr) minmax(0, 1.1fr);\n  align-items: start;\n  gap: 16px;\n  padding: 16px;\n  min-height: 0;\n  min-width: 0;\n  overflow: auto;\n  box-sizing: border-box;\n  color: #fff;\n  background: radial-gradient(circle, #07af64 0%, #128a80 58%, #19dccf 100%);\n}\n\n.scada-dash-left-column,\n.scada-dash-right-column {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  gap: 14px;\n}\n\n.scada-dash-status-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px;\n  border-radius: 6px;\n  color: #f1f5f9;\n  background: radial-gradient(ellipse at top right, #586170 0%, #586170 38%, transparent 38%), #3c4556;\n}\n\n.scada-dash-status-bar > div:first-child {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.scada-dash-status-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #f1f5f9;\n  text-transform: uppercase;\n}\n\n.scada-dash-status-live {\n  flex-shrink: 0;\n  padding: 3px 6px;\n}\n\n.scada-dash-row-container {\n  display: flex;\n  align-items: center;\n}\n\n.scada-dash-status-badge {\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #040c32;\n  background: #1ded88;\n}\n\n.scada-dash-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.scada-dash-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-width: 0;\n  min-height: 118px;\n  padding: 12px;\n  border: 1px solid #d6e5e9;\n  border-radius: 6px;\n  color: #fff !important;\n  background: #000 !important;\n}\n\n.scada-dash-card-header {\n  padding: 4px 0;\n  color: #e5e7eb !important;\n  font-size: 13px;\n}\n\n.scada-dash-card-title {\n  text-transform: uppercase;\n  overflow-wrap: anywhere;\n  letter-spacing: 0.04em;\n}\n\n.scada-dash-card-value {\n  padding: 12px 0;\n  color: #fff !important;\n  font-size: 22px;\n  font-weight: 600;\n  text-align: center;\n  overflow-wrap: anywhere;\n}\n\n.scada-dash-card-unit {\n  color: #e5e7eb !important;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.scada-dash-card-footer {\n  color: #ecf1ef !important;\n  font-size: 10px;\n}\n\n/* Keep readings visible, including measurements above the configured limit. */\n.scada-dash-card-danger .scada-dash-card-value {\n  color: #ff6b6b !important;\n}\n\n.scada-dash-info-header,\n.scada-dash-map-card {\n  padding: 10px;\n  border: 1px solid #2f3a56;\n  border-radius: 8px;\n  background: #0b1020;\n}\n\n.scada-dash-labelULB {\n  padding: 10px;\n  border-radius: 8px;\n  background: #7d15c2;\n  color: #fff;\n}\n\n.scada-dash-label {\n  color: #ffe600;\n}\n\n.scada-dash-labeBack {\n  background: #bca5cb;\n  color: #17031f;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.scada-dash-map-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 260px;\n  margin-bottom: 12px;\n  border: 1px solid #1f2937;\n  border-radius: 6px;\n  background: radial-gradient(circle at top, #1f2937, #020617);\n}\n\n.scada-dash-bottom-section:empty {\n  display: none;\n}\n\n@media (max-width: 1200px) {\n  .scada-dash-page {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 640px) {\n  .scada-dash-cards-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n  }\n\n  .scada-dash-status-bar > div:first-child {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
